import React from 'react';
import './Sidebar.css';
import cadscribeLogo from '../../assets/cadscribe.png';

const Sidebar = ({
  isOpen,
  userName,
  freeMessages,
  chatId,
  onNewChat,
  toggleModel,
  isThinkingModel,
  fileFormat,
  setFileFormat,
  chatHistory,
  onSelectChat,
  userProduct,
  onManageSubscription,
  onUpgradeSubscription
}) => {
  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="logo-container">
        <a href="https://www.cadscribelabs.com/">
          <img src={cadscribeLogo} alt="CADscribe Logo" className="logo" />
        </a>
      </div>
      <div className="sidebar-scrollable-content">
        <div><span>Welcome, {userName}</span></div>
        <span className="free-messages-count">{freeMessages} messages used</span>
        <span className="chat-id">{chatId}</span>
        
        <button 
          id="newChatBtn" 
          className="sidebar-btn" 
          onClick={onNewChat}
        >
          New Chat
        </button>
        
        <div className="model-toggle">
          <label htmlFor="modelToggle">
            Thinking Model
            <span className="tooltip">
              <i
                className="fas fa-info-circle"
                title="This model will be slower but more accurate"
                style={{ marginLeft: '5px', cursor: 'help' }}
              ></i>
            </span>
            :
          </label>
          <div className={`switch-container ${userProduct === 'premium' ? '' : 'premium-required'}`}>
            <label className="switch">
              <input
                type="checkbox"
                id="modelToggle"
                checked={isThinkingModel}
                onChange={toggleModel}
              />
              <span className="slider"></span>
            </label>
            {userProduct !== 'premium' && (
              <div className="premium-alert">
                <i className="fas fa-lock"></i>Subscription required
              </div>
            )}
          </div>
        </div>
        
        <div className="file-format-select">
          <label htmlFor="fileFormatSelect">File Format:</label>
          <select
            id="fileFormatSelect"
            value={fileFormat}
            onChange={(e) => setFileFormat(e.target.value)}
          >
            <option value="step">STEP</option>
            <option value="stl">STL</option>
          </select>
        </div>

        {/* Subscription management section */}
        <div className="subscription-section">
          {userProduct === 'premium' ? (
            <button
              className="sidebar-btn subscription-btn"
              onClick={onManageSubscription}
            >
              Manage Subscription
            </button>
          ) : (
            <button
              className="sidebar-btn subscription-btn upgrade-btn"
              onClick={onUpgradeSubscription}
            >
              Upgrade to Premium
            </button>
          )}
        </div>

        </div>
      <div className="chat-history">
        <h3>Chat History</h3>
        <div className="chat-list">
          {chatHistory.map((chat) => (
            <button
              key={chat.id}
              className="chat-history-btn"
              onClick={() => onSelectChat(chat.id)}
            >
              {chat.id}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
